import {urlForSpace} from "@src/utils/endpoints-urls";


export function urlForUsers(spaceId: string): string {
	return `${urlForSpace(spaceId)}/users`;
}


export function urlForUser(spaceId: string,
                           userId: string): string {
	return `${urlForUsers(spaceId)}/${userId}`;
}

export function urlForUsersRoles(spaceId: string): string {
	return `${urlForUsers(spaceId)}/roles`;
}

export function urlForAddUser(spaceId: string): string {
	return `${urlForUsers(spaceId)}/add_user`;
}
